module.exports = __webpack_public_path__ + "static/media/confetti.4a7210b0.png";